module.exports = __webpack_public_path__ + "static/media/session1.58301cf4.png";